import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Success from "@/pages/Success";
import Cancel from "@/pages/Cancel";
import Contact from "@/pages/Contact";
import Gallery from "@/pages/Gallery";
import CGV from "@/pages/CGV";
import Privacy from "@/pages/Privacy";
import CookiesPage from "@/pages/CookiesPage";
import Admin from "@/pages/Admin";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { CookieBanner } from "@/components/CookieBanner";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/success" element={<Success />} />
            <Route path="/cancel" element={<Cancel />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/cgv" element={<CGV />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookies" element={<CookiesPage />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" richColors />
      </LanguageProvider>
    </div>
  );
}

export default App;
